import { SpecFilterGroup } from '@/components/catalogue/products/useFilteredProducts';
import { createContext, useContext } from 'react';
import { StoreApi, useStore } from 'zustand';
import { Manufacturer } from '../api/contracts/catalog/types';

export interface CatalogueExplorerFilterService {
  specFilters: SpecFilterGroup[];
  setSpecFilter: (specs: SpecFilterGroup[]) => void;
  clearSpec: (spec: string) => void;
  manufacturerFilters: Manufacturer[];
  setManufacturerFilters: (manufacturer: Manufacturer[]) => void;
  clearManufacturer: (manufacturerId: string) => void;
  clearAll: () => void;
}

export const CatalogueExplorerFilterContext = createContext<StoreApi<CatalogueExplorerFilterService> | null>(null);

export function useCatalogueExplorerFilterService<U>(selector: (store: CatalogueExplorerFilterService) => U): U {
  const context = useContext(CatalogueExplorerFilterContext);
  if (!context) {
    throw new Error('useCatalogueExplorerFilterService must be used within a CatalogueExplorerFilterProvider');
  }
  return useStore(context, selector);
}
